/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { sharedURLs, environment } from "@insticator/insticator-ui"; // iui-utils



// .......... ANIMATION SPEED .......... //
export const aniSpeed = '.15s';



// .......... HOVER TRANSITION .......... //
export const hoverTransition = (el='all') => ({
    transition: `${el} ${aniSpeed} ease-in-out 0s`
});



